import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import { toast } from "react-toastify";
import { save, putUser } from "../../api/UsersApi";
import { useSelector } from "react-redux";
function CreateUser(props) {
  const [userName, setName] = useState("");
  const [role, setRole] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [id, setId] = useState(null);
  const userData = useSelector((state) => state.userSetter);

  console.log("User data is ... ", role);
  useEffect(() => {

    if (props.history.location.state) {
      let user = props.history.location.state;
      setEmail(user.email);
      setRole(user.role);
      setPhone(user.phone);
      setName(user.name);
      setId(user.id);
    }
  }, []);
  function saveUser(e) {
    e.preventDefault();
    let user = {
      name: userName,
      role: role,
      email: email,
      phone: phone,
    };

    if (id) {
      putUser(id, user)
        .then(function (data) {
          toast.success("User has been saved successfully");
          props.history.push("/admin/settings/users");

        })
        .catch(function (error) {
          toast.error(error.response.data.message || "Error saving user");


        });

      return;
    }
    user.status = "active";
    save(user)
      .then(function (data) {
        toast.success("User has been saved successfully");
        props.history.push("/admin/settings/users");
      })
      .catch(function (error) {

        toast.error(error.response.data.message ||
          "There was an error creating the user. Please try again later."
        );
      });
  }

  return (
    <div>
      <div className="page_heading">
        <h2>Create User</h2>
      </div>
      <form onSubmit={saveUser}>
        <div className="audieneOuter">
          <div className="inputOuter" style={{ width: "50%" }}>
            <label className="large">User Name</label>
            <input
              id="audienceName"
              value={userName}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="kwDesign "
              required
            />
          </div>
          <div className="inputOuter" style={{ width: "50%" }}>
            <label className="large">Email</label>
            <input
              value={email}
              id="audienceName"
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              className="kwDesign "
              required
            />
          </div>
          <div style={{ display: "flex" }}>
            <div
              className="inputOuter"
              style={{ flex: "0.52", marginRight: "20px" }}
            >
              <label className="large"> Phone</label>
              <input
                id="audienceName"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="kwDesign"
              />
            </div>

            <div id="display" className="inputOuter" style={{ flex: "0.5" }}>
              <label className="large">Role</label>
              <select
                id="dropDown"
                className="kwDesign2"
                style={{ width: "100%" }}
                required
                onChange={(e) => setRole(e.target.value)}
                value={role}

              //   onChange={handleChoice}
              >
                <option value="">Select</option>
                {userData.role === "publisher" ? (
                  <>
                    <option value="publisher">Publisher</option>
                    <option value="partner">Partner</option>
                  </>
                ) : (
                  <>
                    <option value="admin">Admin</option>
                    <option value="marketing">Marketing</option>
                    <option value="designer">Designer</option>
                    <option value="developer">Developer</option>
                    <option value="sales">Sales</option>
                    {userData.companyLevelComplaiceFlag ? (
                      <option value="compliance">Compliance</option>
                    ) : (
                      <option value="compliance" disabled>
                        Compliance
                      </option>
                    )}
                  </>
                  )}
              </select>
            </div>
          </div>

          <div className="previewAudience" style={{ marginTop: "2vh" }}>
            <input
              type="submit"
              name="Save"
              style={{ margin_top: "2v", cursor: "pointer" }}
              className="lg_btn primary"
              value="Save User"
            />
            <span className='ml-3'></span>
            <a
              // onClick={routeChangetocancel}
              className="lg_btn tertiary"
              type="reset"
              onClick={(e) => {
                e.preventDefault();
                props.history.push(`/admin/settings/users`);
              }}
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateUser;
